var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { pick } from "lodash";
import Menu from "react-icons/lib/md/menu";
import Info from "react-icons/lib/md/info-outline";
import BackArrow from "react-icons/lib/md/arrow-back";
import UpArrow from "react-icons/lib/fa/chevron-up";
import AngleLeft from "react-icons/lib/fa/angle-left";
import AngleRight from "react-icons/lib/fa/angle-right";
import Plus from "react-icons/lib/fa/plus";
import OldComment from "react-icons/lib/fa/comment-o";
import OldCommented from "react-icons/lib/fa/comment";
import Vote from "react-icons/lib/fa/heart-o";
import Voted from "react-icons/lib/fa/heart";
import OldReward from "react-icons/lib/fa/gift";
import Play from "react-icons/lib/fa/play";
import Pause from "react-icons/lib/fa/pause";
import Trashcan from "react-icons/lib/fa/trash-o";
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes";
import EditPencil from "react-icons/lib/fa/edit";
import Ellipsis from "react-icons/lib/fa/ellipsis-h";
import AddAdmin from "./customIcons/AddAdmin";
import Apps from "./customIcons/Apps";
import DownArrow from "./customIcons/DownArrow";
import DownloadFile from "./customIcons/DownloadFile";
import Tick from "./customIcons/Tick";
import CircleTick from "./customIcons/CircleTick";
import Perks from "./customIcons/Perks";
import LogoBox from "./customIcons/LogoBox";
import Close from "./customIcons/Close";
import RightArrow from "./customIcons/RightArrow";
import Comment from "./customIcons/Comment";
import AddComment from "./customIcons/AddComment";
import AddEmoji from "./customIcons/AddEmoji";
import Emoji from "./customIcons/Emoji";
import EmojiActive from "./customIcons/EmojiActive";
import AddReward from "./customIcons/AddReward";
import Reward from "./customIcons/Reward";
import CustomReward from "./customIcons/CustomReward";
import RewardActive from "./customIcons/RewardActive";
import Physical from "./customIcons/TopUpCard";
import Coupon from "./customIcons/Ticket";
import Instant from "./customIcons/Instant";
import OneHour from "./customIcons/Time";
import Payment from "./customIcons/Payment";
import Favourite from "./customIcons/HeartFilled";
import FavouriteOutline from "./customIcons/Heart";
import SimpleFavourite from "./customIcons/SimpleHeartFilled";
import SimpleFavouriteOutline from "./customIcons/SimpleHeart";
import NewTab from "./customIcons/NewTab";
import Landscape from "./customIcons/Landscape";
import Search from "./customIcons/Search";
import Question from "./customIcons/Question";
import CompanyBenefit from "./customIcons/CompanyBenefit";
import Attachment from "./customIcons/Attachment";
import Pin from "./customIcons/Pin";
import PinFilled from "./customIcons/PinFilled";
import Visibility from "./customIcons/Visibility";
import Wallet from "./customIcons/Wallet";
import GeoPin from "./customIcons/GeoPin";
import GeoArrow from "./customIcons/GeoArrow";
import SummaryComments from "./customIcons/SummaryComments";
import SummaryRecognitions from "./customIcons/SummaryRecognitions";
import SummaryTrophies from "./customIcons/SummaryTrophies";
import DotDotDot from "./customIcons/DotDotDot";
import I from "./customIcons/I";
import Padlock from "./customIcons/Padlock";
import Lightbulb from "./customIcons/Lightbulb";
import People from "./customIcons/People";
import Person from "./customIcons/Person";
import Edit from "./customIcons/Edit";
import SendExampleSurvey from "./customIcons/SendExampleSurvey";
import Stop from "./customIcons/Stop";
import Duplicate from "./customIcons/Duplicate";
import Archive from "./customIcons/Archive";
import Delete from "./customIcons/Delete";
import Launch from "./customIcons/Launch";
import SeeResults from "./customIcons/SeeResults";
import Restore from "./customIcons/Restore";
import MySurveys from "./customIcons/MySurveys";
import EditQuestion from "./customIcons/EditQuestion";
import DisabledEditQuestion from "./customIcons/DisabledEditQuestion";
import EyeSlash from "./customIcons/EyeSlash";
import Eye from "./customIcons/Eye";
import More from "./customIcons/More";
import PerksGO from "./customIcons/PerksGO";
import Calendar from "./customIcons/Calendar";
import Poll from "./customIcons/Poll";
import Share from "./customIcons/Share";
import HeartOutline from "./customIcons/HeartOutline";
import Send from "./customIcons/Send";
import Report from "./customIcons/Report";
import Tag from "./customIcons/Tag";
import Sort from "./customIcons/Sort";
import Filter from "./customIcons/Filter";
import FilterActive from "./customIcons/FilterActive";
import User from "./customIcons/User";
import Logout from "./customIcons/Logout";
import Help from "./customIcons/Help";
import Home from "./customIcons/Home";
import MyPerks from "./customIcons/MyPerks";
import MyRecognition from "./customIcons/MyRecognition";
import DoctorCareAnywhere from "./customIcons/DoctorCareAnywhere";
import RemoveBookmark from "./customIcons/RemoveBookmark";
import AddBookmark from "./customIcons/AddBookmark";
import MobileSecondaryNav from "./customIcons/MobileSecondaryNav";
import MobileAppOnly from "./customIcons/MobileAppOnly";
import TimeLimitedPerk from "./customIcons/TimeLimitedPerk";
import ProductsPerks from "./customIcons/Product-Perks";
import ProductsInsights from "./customIcons/Product-Insights";
import ProductsMedical from "./customIcons/Product-Medical";
import ProductsRecognition from "./customIcons/Product-Recognition";
import CircleHollow from "./customIcons/CircleHollow";
import Announcement from "./customIcons/Announcement";
import Blog from "./customIcons/Blog";
import Clipboard from "./customIcons/Clipboard";
import Clock from "./customIcons/Clock";
import Event from "./customIcons/Event";
import Newsletter from "./customIcons/Newsletter";
import Party from "./customIcons/Party";
import PlayVideo from "./customIcons/PlayVideo";
import Reminder from "./customIcons/Reminder";
import Values from "./customIcons/Values";
import FileDownload from "./customIcons/FileDownload";
import SharedUser from "./customIcons/SharedUser";
import Online from "./customIcons/Online";
import IconTypes from "./IconTypes.enum";
var Icon = function (props) {
    var whitelistedProperties = pick(props, ["id", "className", "children", "color", "size", "style", "type", "alt"]);
    switch (props.icon) {
        case IconTypes.addAdmin:
            return React.createElement(AddAdmin, __assign({}, whitelistedProperties));
        case IconTypes.apps:
            return React.createElement(Apps, __assign({}, whitelistedProperties));
        case IconTypes.menu:
            return React.createElement(Menu, __assign({}, whitelistedProperties));
        case IconTypes.info:
            return React.createElement(Info, __assign({ className: "icon" }, whitelistedProperties));
        case IconTypes.backArrow:
            return React.createElement(BackArrow, __assign({}, whitelistedProperties));
        case IconTypes.upArrow:
            return React.createElement(UpArrow, __assign({}, whitelistedProperties));
        case IconTypes.downArrow:
            return React.createElement(DownArrow, __assign({}, whitelistedProperties));
        case IconTypes.rightArrow:
            return React.createElement(RightArrow, __assign({}, whitelistedProperties));
        case IconTypes.payment:
            return React.createElement(Payment, __assign({}, whitelistedProperties));
        case IconTypes.search:
            return React.createElement(Search, __assign({}, whitelistedProperties));
        case IconTypes.trashcan:
            return React.createElement(Trashcan, __assign({}, whitelistedProperties));
        case IconTypes.angleLeft:
            return React.createElement(AngleLeft, __assign({}, whitelistedProperties));
        case IconTypes.angleRight:
            return React.createElement(AngleRight, __assign({}, whitelistedProperties));
        case IconTypes.favourite:
            return React.createElement(Favourite, __assign({}, whitelistedProperties));
        case IconTypes.favouriteOutline:
            return React.createElement(FavouriteOutline, __assign({}, whitelistedProperties));
        case IconTypes.simpleFavourite:
            return React.createElement(SimpleFavourite, __assign({}, whitelistedProperties));
        case IconTypes.simpleFavouriteOutline:
            return React.createElement(SimpleFavouriteOutline, __assign({}, whitelistedProperties));
        case IconTypes.newTab:
            return React.createElement(NewTab, __assign({}, whitelistedProperties));
        case IconTypes.landscape:
            return React.createElement(Landscape, __assign({}, whitelistedProperties));
        case IconTypes.question:
            return React.createElement(Question, __assign({}, whitelistedProperties));
        case IconTypes.tick:
            return React.createElement(Tick, __assign({}, whitelistedProperties));
        case IconTypes.circleTick:
            return React.createElement(CircleTick, __assign({}, whitelistedProperties));
        case IconTypes.circleHollow:
            return React.createElement(CircleHollow, __assign({}, whitelistedProperties));
        case IconTypes.perks:
            return React.createElement(Perks, __assign({}, whitelistedProperties));
        case IconTypes.logoBox:
            return React.createElement(LogoBox, __assign({}, whitelistedProperties));
        case IconTypes.close:
            return React.createElement(Close, __assign({}, whitelistedProperties));
        case IconTypes.oldComment:
            return React.createElement(OldComment, __assign({}, whitelistedProperties));
        case IconTypes.oldCommented:
            return React.createElement(OldCommented, __assign({}, whitelistedProperties));
        case IconTypes.comment:
            return React.createElement(Comment, __assign({}, whitelistedProperties));
        case IconTypes.addComment:
            return React.createElement(AddComment, __assign({}, whitelistedProperties));
        case IconTypes.emoji:
            return React.createElement(Emoji, __assign({}, whitelistedProperties));
        case IconTypes.emojiActive:
            return React.createElement(EmojiActive, __assign({}, whitelistedProperties));
        case IconTypes.addEmoji:
            return React.createElement(AddEmoji, __assign({}, whitelistedProperties));
        case IconTypes.reward:
            return React.createElement(Reward, __assign({}, whitelistedProperties));
        case IconTypes.customReward:
            return React.createElement(CustomReward, __assign({}, whitelistedProperties));
        case IconTypes.rewardActive:
            return React.createElement(RewardActive, __assign({}, whitelistedProperties));
        case IconTypes.addReward:
            return React.createElement(AddReward, __assign({}, whitelistedProperties));
        case IconTypes.plus:
            return React.createElement(Plus, __assign({}, whitelistedProperties));
        case IconTypes.vote:
            return React.createElement(Vote, __assign({}, whitelistedProperties));
        case IconTypes.voted:
            return React.createElement(Voted, __assign({}, whitelistedProperties));
        case IconTypes.oldReward:
            return React.createElement(OldReward, __assign({}, whitelistedProperties));
        case IconTypes.play:
            return React.createElement(Play, __assign({}, whitelistedProperties));
        case IconTypes.pause:
            return React.createElement(Pause, __assign({}, whitelistedProperties));
        case IconTypes.attachment:
            return React.createElement(Attachment, __assign({}, whitelistedProperties));
        case IconTypes.pin:
            return React.createElement(Pin, __assign({}, whitelistedProperties));
        case IconTypes.pinFilled:
            return React.createElement(PinFilled, __assign({}, whitelistedProperties));
        case IconTypes.visibility:
            return React.createElement(Visibility, __assign({}, whitelistedProperties));
        case DealHighlightTypes.DIGITAL:
            return React.createElement(Coupon, __assign({}, whitelistedProperties));
        case DealHighlightTypes.COMPANY_BENEFIT:
            return React.createElement(CompanyBenefit, __assign({}, whitelistedProperties));
        case DealHighlightTypes.PHYSICAL:
            return React.createElement(Physical, __assign({}, whitelistedProperties));
        case DealHighlightTypes.COUPON:
            return React.createElement(Coupon, __assign({}, whitelistedProperties));
        case DealHighlightTypes.INSTANT:
            return React.createElement(Instant, __assign({}, whitelistedProperties));
        case DealHighlightTypes.ONE_HOUR:
            return React.createElement(OneHour, __assign({}, whitelistedProperties));
        case DealHighlightTypes.APP_ONLY:
            return React.createElement(MobileAppOnly, __assign({}, whitelistedProperties));
        case DealHighlightTypes.TIME_LIMIT_24_HOUR:
            return React.createElement(TimeLimitedPerk, __assign({}, whitelistedProperties));
        case IconTypes.perksGO:
            return React.createElement(PerksGO, __assign({}, whitelistedProperties));
        case IconTypes.wallet:
            return React.createElement(Wallet, __assign({}, whitelistedProperties));
        case IconTypes.geoPin:
            return React.createElement(GeoPin, __assign({}, whitelistedProperties));
        case IconTypes.geoArrow:
            return React.createElement(GeoArrow, __assign({}, whitelistedProperties));
        case IconTypes.summaryComments:
            return React.createElement(SummaryComments, __assign({}, whitelistedProperties));
        case IconTypes.summaryRecognitions:
            return React.createElement(SummaryRecognitions, __assign({}, whitelistedProperties));
        case IconTypes.summaryTrophies:
            return React.createElement(SummaryTrophies, __assign({}, whitelistedProperties));
        case IconTypes.dotDotDot:
            return React.createElement(DotDotDot, __assign({}, whitelistedProperties));
        case IconTypes.i:
            return React.createElement(I, __assign({}, whitelistedProperties));
        case IconTypes.padlock:
            return React.createElement(Padlock, __assign({}, whitelistedProperties));
        case IconTypes.lightbulb:
            return React.createElement(Lightbulb, __assign({}, whitelistedProperties));
        case IconTypes.person:
            return React.createElement(Person, __assign({}, whitelistedProperties));
        case IconTypes.people:
            return React.createElement(People, __assign({}, whitelistedProperties));
        case IconTypes.edit:
            return React.createElement(Edit, __assign({}, whitelistedProperties));
        case IconTypes.sendExampleSurvey:
            return React.createElement(SendExampleSurvey, __assign({}, whitelistedProperties));
        case IconTypes.stop:
            return React.createElement(Stop, __assign({}, whitelistedProperties));
        case IconTypes.duplicate:
            return React.createElement(Duplicate, __assign({}, whitelistedProperties));
        case IconTypes.archive:
            return React.createElement(Archive, __assign({}, whitelistedProperties));
        case IconTypes.launch:
            return React.createElement(Launch, __assign({}, whitelistedProperties));
        case IconTypes.seeResults:
            return React.createElement(SeeResults, __assign({}, whitelistedProperties));
        case IconTypes.editQuestion:
            return React.createElement(EditQuestion, __assign({}, whitelistedProperties));
        case IconTypes.disabledEditQuestion:
            return React.createElement(DisabledEditQuestion, __assign({}, whitelistedProperties));
        case IconTypes.eyeSlash:
            return React.createElement(EyeSlash, __assign({}, whitelistedProperties));
        case IconTypes.eye:
            return React.createElement(Eye, __assign({}, whitelistedProperties));
        case IconTypes.restore:
            return React.createElement(Restore, __assign({}, whitelistedProperties));
        case IconTypes.delete:
            return React.createElement(Delete, __assign({}, whitelistedProperties));
        case IconTypes.mySurveys:
            return React.createElement(MySurveys, __assign({}, whitelistedProperties));
        case IconTypes.more:
            return React.createElement(More, __assign({}, whitelistedProperties));
        case IconTypes.calendar:
            return React.createElement(Calendar, __assign({}, whitelistedProperties));
        case IconTypes.ellipsis:
            return React.createElement(Ellipsis, __assign({}, whitelistedProperties));
        case IconTypes.report:
            return React.createElement(Report, __assign({}, whitelistedProperties));
        case IconTypes.poll:
            return React.createElement(Poll, __assign({}, whitelistedProperties));
        case IconTypes.share:
            return React.createElement(Share, __assign({}, whitelistedProperties));
        case IconTypes.sharedUser:
            return React.createElement(SharedUser, __assign({}, whitelistedProperties));
        case IconTypes.heartOutline:
            return React.createElement(HeartOutline, __assign({}, whitelistedProperties));
        case IconTypes.send:
            return React.createElement(Send, __assign({}, whitelistedProperties));
        case IconTypes.tag:
            return React.createElement(Tag, __assign({}, whitelistedProperties));
        case IconTypes.sort:
            return React.createElement(Sort, __assign({}, whitelistedProperties));
        case IconTypes.filter:
            return React.createElement(Filter, __assign({}, whitelistedProperties));
        case IconTypes.filterActive:
            return React.createElement(FilterActive, __assign({}, whitelistedProperties));
        case IconTypes.removeBookmark:
            return React.createElement(RemoveBookmark, __assign({}, whitelistedProperties));
        case IconTypes.addBookmark:
            return React.createElement(AddBookmark, __assign({}, whitelistedProperties));
        case IconTypes.user:
            return React.createElement(User, __assign({}, whitelistedProperties));
        case IconTypes.logout:
            return React.createElement(Logout, __assign({}, whitelistedProperties));
        case IconTypes.help:
            return React.createElement(Help, __assign({}, whitelistedProperties));
        case IconTypes.home:
            return React.createElement(Home, __assign({}, whitelistedProperties));
        case IconTypes.myPerks:
            return React.createElement(MyPerks, __assign({}, whitelistedProperties));
        case IconTypes.myRecognition:
            return React.createElement(MyRecognition, __assign({}, whitelistedProperties));
        case IconTypes.dca:
            return React.createElement(DoctorCareAnywhere, __assign({}, whitelistedProperties));
        case IconTypes.mobileSecondaryNav:
            return React.createElement(MobileSecondaryNav, __assign({}, whitelistedProperties));
        case IconTypes.editPencil:
            return React.createElement(EditPencil, __assign({}, whitelistedProperties));
        case IconTypes.downloadFile:
            return React.createElement(DownloadFile, __assign({}, whitelistedProperties));
        case IconTypes.productsPerks:
            return React.createElement(ProductsPerks, __assign({}, whitelistedProperties));
        case IconTypes.productsInsights:
            return React.createElement(ProductsInsights, __assign({}, whitelistedProperties));
        case IconTypes.productsMedical:
            return React.createElement(ProductsMedical, __assign({}, whitelistedProperties));
        case IconTypes.productsRecognition:
            return React.createElement(ProductsRecognition, __assign({}, whitelistedProperties));
        case IconTypes.announcement:
            return React.createElement(Announcement, __assign({}, whitelistedProperties));
        case IconTypes.event:
            return React.createElement(Event, __assign({}, whitelistedProperties));
        case IconTypes.values:
            return React.createElement(Values, __assign({}, whitelistedProperties));
        case IconTypes.party:
            return React.createElement(Party, __assign({}, whitelistedProperties));
        case IconTypes.playVideo:
            return React.createElement(PlayVideo, __assign({}, whitelistedProperties));
        case IconTypes.reminder:
            return React.createElement(Reminder, __assign({}, whitelistedProperties));
        case IconTypes.clipboard:
            return React.createElement(Clipboard, __assign({}, whitelistedProperties));
        case IconTypes.blog:
            return React.createElement(Blog, __assign({}, whitelistedProperties));
        case IconTypes.clock:
            return React.createElement(Clock, __assign({}, whitelistedProperties));
        case IconTypes.newsletter:
            return React.createElement(Newsletter, __assign({}, whitelistedProperties));
        case IconTypes.fileDownload:
            return React.createElement(FileDownload, __assign({}, whitelistedProperties));
        case IconTypes.online:
            return React.createElement(Online, __assign({}, whitelistedProperties));
        default:
            return React.createElement("span", null);
    }
};
var StyledIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", "px;\n  ", "\n"], ["\n  font-size: ", "px;\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return (size || 16);
}, function (_a) {
    var margin = _a.margin;
    return margin && "margin: " + margin + ";";
});
export default StyledIcon;
export { default as IconTypes } from "./IconTypes.enum";
var templateObject_1;
